module.exports = __webpack_public_path__ + "static/media/Chat_image.5f86d236.png";